module.exports = __webpack_public_path__ + "img/checked.7de71b8a.svg";